import qs from 'query-string';
import { get } from '../baseApi';

export const PlanApi = {
    fetch: (query) => get(`/admin/plans?${qs.stringify(query)}`),
};
